import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, map, take } from 'rxjs';
import { LoginService } from '../../app/service/auth-service/login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private loginService: LoginService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    
    // Use the authentication state to check if user is authenticated
    return this.loginService.authUser$.pipe(
      take(1), // Take only the current value
      map(user => {
        if (user) {
          // User is authenticated
          return true;
        } else {
          // User is not authenticated, redirect to login with return URL
          return this.router.createUrlTree(['/auth/login'], { 
            queryParams: { returnUrl: state.url }
          });
        }
      })
    );
  }
}
